import { stringifyQueryString, useQuery } from '@fv/client-core'
import type { SpotQuotePreviewDTO, SpotQuotePreviewResponse } from '@fv/models'

import { shipperFetch } from '@/utils/shipperFetch'

const fetchSpotQuoteEmailPreview = async (query: SpotQuotePreviewDTO) => {
  return shipperFetch<SpotQuotePreviewResponse>(
    `/spot-quotes/preview/spot-quote-request`,
    {
      query: stringifyQueryString(query),
    },
  )
}

type UseSpotQuoteEmailPreviewArgs = SpotQuotePreviewDTO & {
  isOpen: boolean
}
export function useSpotQuoteEmailPreview({
  isOpen,
  ...query
}: UseSpotQuoteEmailPreviewArgs) {
  return useQuery(
    ['spot-quote-email-preview', query],
    () => fetchSpotQuoteEmailPreview(query),
    {
      enabled: Boolean(isOpen && query.loadId),
    },
  )
}
